import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { socket, SocketContext } from './socket/socketio';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<SocketContext.Provider value={socket}> <App /></SocketContext.Provider>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
